import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { AppConfigService } from 'src/app/app-config.service';
import { AuthService } from '../services/auth.service';

@Injectable({
	providedIn: 'root'
})
export /**
 * This guard can be used to only activate a route if the app state 'isLoggedIn' is true AND user is NOT an insurance agent.
 */
class LoggedInGuardService implements CanActivate {
	constructor(private authService: AuthService, private configService: AppConfigService) {}

	async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
		const isLoggedIn = this.authService.isLoggedIn();
		const userInfo = await this.authService.getUserInfo().toPromise();

		// Only activate route if user is logged-in.
		if (isLoggedIn && !userInfo.isAgentUser) {
			return true;
		} else {
			//Otherwise, go to the 'not authorized' page.
			window.location.href = this.configService.getConfig().loginUrl;
			return false;
		}
	}
}

@Injectable({
	providedIn: 'root'
})
export /**
 * This guard can be used to only activate a route if the app state 'isLoggedIn' is true AND user is an insurance agent.
 */
class LoggedInAgentGuardService implements CanActivate {
	constructor(private authService: AuthService, private configService: AppConfigService) {}

	async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
		const isLoggedIn = this.authService.isLoggedIn();
		const userInfo = await this.authService.getUserInfo().toPromise();

		// Only activate route if user is logged-in.
		if (isLoggedIn && userInfo.isAgentUser) {
			return true;
		} else {
			//Otherwise, go to the 'not authorized' page.
			window.location.href = this.configService.getConfig().loginUrl;
			return false;
		}
	}
}